<template>
    <footer class="footer has-cards">

        <div class="container">
            <hr>
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-pink font-weight-light mb-2">Envie de mieux manger !</h3>
                    <h5 class="mb-0 font-weight-light">Laissez-vous tenter par votre épicerie de quartier, éthique et éco-responsable.</h5>
                </div>

            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a
                            href="/"
                            class="text-default"
                            rel="noopener"
                        > - Azterren
                        </a>
                        <p class="copyright">
                            Epicerie éco-responsable
                        </p>
                    </div>
                </div>
                <div class="col-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <router-link
                                to="/principe"
                                class="nav-link"
                            >
                                <span class="nav-link-color">
                                    Le Principe
                                </span>
                            </router-link>
                        </li>
                        <!-- MENUE FOOTER PARTENAIRES & PRODUCTEURS 
                        <li class="nav-item">
                            <a
                                href="#"
                                class="nav-link"
                                rel="noopener"
                            >
                                Nos produits
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href="#"
                                class="nav-link"
                                rel="noopener"
                            >
                                Nos partenaires
                            </a>
                        </li>
-->
                        <li class="nav-item">
                            <router-link
                                to="/contact"
                                class="nav-link"
                            >
                                <span class="nav-link-color">
                                    Contact
                                </span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>
<style>
</style>
